import React from "react";
import { 
    FacebookShareButton, FacebookIcon,
    TwitterShareButton, TwitterIcon,
    WhatsappShareButton, WhatsappIcon,
    TelegramShareButton, TelegramIcon,
    LinkedinShareButton, LinkedinIcon,
    PinterestShareButton, PinterestIcon
} from "react-share";

import "./index.css";

const ShareThis = ({click}) => {
    
    const shareUrl = typeof window !== 'undefined' ? window.location.href : '';

    const handleShare = (network) => {
        if (click !== undefined) {
            click(network);
        }
    };

    const iconProps = { size: 50, borderRadius: 4 };
    const buttonStyle = { marginRight: '8px' };

    return (
        <div className="d-flex flex-row flex-wrap">
            <FacebookShareButton url={shareUrl} style={buttonStyle} onShareWindowClose={() => handleShare('facebook')}>
                <FacebookIcon {...iconProps} />
            </FacebookShareButton>
            
            <TwitterShareButton url={shareUrl} style={buttonStyle} onShareWindowClose={() => handleShare('twitter')}>
                <TwitterIcon {...iconProps} />
            </TwitterShareButton>

            <WhatsappShareButton url={shareUrl} style={buttonStyle} onShareWindowClose={() => handleShare('whatsapp')}>
                <WhatsappIcon {...iconProps} />
            </WhatsappShareButton>

            <TelegramShareButton url={shareUrl} style={buttonStyle} onShareWindowClose={() => handleShare('telegram')}>
                <TelegramIcon {...iconProps} />
            </TelegramShareButton>

            <LinkedinShareButton url={shareUrl} style={buttonStyle} onShareWindowClose={() => handleShare('linkedin')}>
                <LinkedinIcon {...iconProps} />
            </LinkedinShareButton>

            <PinterestShareButton url={shareUrl} style={buttonStyle} media={shareUrl} onShareWindowClose={() => handleShare('pinterest')}>
                <PinterestIcon {...iconProps} />
            </PinterestShareButton>
        </div>
    );
}

export default ShareThis;